export default __webpack_public_path__ + "60dd71089e9e20a3d8c96028cea1999e.png";